import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0983976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_5 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn",
  style: {"min-height":"200px!important"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "ant-upload-drag-icon" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "ant-upload-drag-icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Clique para selecionar ou arraste o arquivo OFX até aqui.", -1))
const _hoisted_12 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-importacao-ofx-grade-personalizada" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-alinhar-texto-centro" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Data")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-9" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Movimento")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor R$")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-alinhar-texto-centro" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Conciliado")
  ])
], -1))
const _hoisted_15 = { class: "ss-importacao-ofx-scroll-movimentos ss-desabilitar-rolagem-horizontal" }
const _hoisted_16 = ["onClick", "id", "title"]
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-alinhar-texto-centro" }
const _hoisted_18 = { class: "ss-margin-campos" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_20 = { class: "ss-margin-campos" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-alinhar-texto-direita" }
const _hoisted_22 = {
  key: 0,
  class: "ss-margin-campos ss-valor-pagamento"
}
const _hoisted_23 = {
  key: 1,
  class: "ss-margin-campos"
}
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-alinhar-texto-direita" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-13 ss-importacao-ofx-coluna-probabilidades" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "ss-importacao-ofx-probabilidades" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_30 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_33 = {
  key: 0,
  class: "ss-importacao-ofx-detalhe-informacao"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Documento:", -1))
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_37 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data do Movimento:", -1))
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_40 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor R$:", -1))
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_43 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Movimento:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-badge-status-dot",
  style: {"background-color":"#FF0000","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-badge-status-dot",
  style: {"background-color":"#33CC00","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_47 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Descrição:", -1))
const _hoisted_49 = {
  key: 0,
  class: "ss-importacao-ofx-detalhe-informacao"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_51 = {
  key: 1,
  class: "ss-importacao-ofx-detalhe-informacao"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_53 = { class: "ss-importacao-ofx-probabilidades" }
const _hoisted_54 = { class: "ant-row" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_56 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_59 = {
  key: 0,
  class: "ss-importacao-ofx-detalhe-informacao"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Documento:", -1))
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_63 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data do Movimento:", -1))
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_66 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor R$:", -1))
const _hoisted_68 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_69 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Movimento:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-badge-status-dot",
  style: {"background-color":"#FF0000","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-badge-status-dot",
  style: {"background-color":"#33CC00","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_73 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Descrição:", -1))
const _hoisted_75 = {
  key: 0,
  class: "ss-importacao-ofx-detalhe-informacao"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_77 = {
  key: 1,
  class: "ss-importacao-ofx-detalhe-informacao"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_79 = { key: 0 }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { class: "ss-importacao-ofx-probabilidades" }
const _hoisted_84 = { class: "ant-row" }
const _hoisted_85 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_86 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_88 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_89 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Documento:", -1))
const _hoisted_91 = { class: "ant-row" }
const _hoisted_92 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_93 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data de Vencimento:", -1))
const _hoisted_95 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_96 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor R$:", -1))
const _hoisted_98 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_100 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_102 = { key: 0 }
const _hoisted_103 = ["onClick"]
const _hoisted_104 = ["onClick"]
const _hoisted_105 = ["onClick"]
const _hoisted_106 = { key: 0 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"900","font-size":"22px","text-align":"center"} }, "Movimentos selecionados para Conciliação", -1))
const _hoisted_108 = { class: "ss-importacao-ofx-probabilidades" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "ant-row" }
const _hoisted_111 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_112 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_114 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_115 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Documento:", -1))
const _hoisted_117 = { class: "ant-row" }
const _hoisted_118 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_119 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data do Movimento:", -1))
const _hoisted_121 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor R$:", -1))
const _hoisted_123 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Movimento:", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-badge-status-dot",
  style: {"background-color":"#FF0000","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-badge-status-dot",
  style: {"background-color":"#33CC00","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_127 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_129 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_131 = { key: 2 }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"900","font-size":"22px","text-align":"center"} }, "Títulos selecionados e disponíveis para baixa", -1))
const _hoisted_133 = { class: "ss-importacao-ofx-probabilidades" }
const _hoisted_134 = ["onClick"]
const _hoisted_135 = { class: "ant-row" }
const _hoisted_136 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_137 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_139 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_140 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Documento:", -1))
const _hoisted_142 = { class: "ant-row" }
const _hoisted_143 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_144 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data de Vencimento:", -1))
const _hoisted_146 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor R$:", -1))
const _hoisted_148 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_150 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_152 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_153 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Juros/Multa:", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, null, -1))
const _hoisted_156 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_157 = { class: "ss-importacao-ofx-detalhe-informacao" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Desconto:", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_160 = [
  _hoisted_159
]
const _hoisted_161 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_162 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_163 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_164 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_card = _resolveComponent("card")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_movimento_financeiro_modal = _resolveComponent("movimento-financeiro-modal")!
  const _component_transferencia_contas_modal = _resolveComponent("transferencia-contas-modal")!
  const _component_buscar_titulos_modal = _resolveComponent("buscar-titulos-modal")!
  const _component_buscar_movimentos_financeiros_modal = _resolveComponent("buscar-movimentos-financeiros-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: "Importação de Extrato - OFX",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1200,
    centered: "",
    "wrap-class-name": _ctx.state.ocultarUpload ? 'scroll-modal ss-modal-financeiro' : 'ss-modal-financeiro',
    footer: null,
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    default: _withCtx(() => [
      (_ctx.modalBase.computedVisivel)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_selecionar_conta, {
                    codigoSelecionado: _ctx.state.codigoConta,
                    "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigoConta) = $event)),
                    descricaoSelecionado: _ctx.state.nomeConta,
                    "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.nomeConta) = $event)),
                    empresas: [_ctx.props.empresa],
                    disabled: _ctx.state.desabilitarSelecaoConta,
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.estrategiaAlteracaoConta()))
                  }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_form_item, {
                    label: "Apresentação dos movimentos",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.state.apresentarStatus,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.apresentarStatus) = $event)),
                        class: "ss-tamanho-completo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Todos")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Apenas Não conciliados")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Apenas Conciliados")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 3 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Apenas Ignorados")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.state.recuperarSalvamentoAutomatico)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui a importação do arquivo: " + _toDisplayString(_ctx.state.nomeArquivo) + " em andamento, deseja recuperar? ", 1),
                      _createVNode(_component_a_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.recuperarSalvamentoAutomatico())),
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
                class: "ant-upload ant-upload-drag",
                onDragover: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("input", {
                    id: "selecionarArquivoOfx",
                    type: "file",
                    accept: "",
                    multiple: "",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoSelecionado && _ctx.uploadArquivoSelecionado(...args))),
                    style: {"display":"none"}
                  }, null, 32),
                  _createElementVNode("div", {
                    class: "ant-upload-drag-container",
                    onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoArrastado && _ctx.uploadArquivoArrastado(...args)))
                  }, [
                    ((_ctx.state.enviandoArquivo))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, [
                            _createVNode(_component_a_spin, { size: "large" })
                          ]),
                          _hoisted_8
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("p", _hoisted_10, [
                            _createVNode(_component_icone, {
                              style: {"font-size":"40px"},
                              nome: "upload-nuvem"
                            })
                          ]),
                          _hoisted_11
                        ]))
                  ], 32)
                ])
              ], 544), [
                [_vShow, !_ctx.state.ocultarUpload]
              ]),
              (_ctx.state.ocultarUpload)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_card, {
                        titulo: 'Movimentações no arquivo - Período: ' + _ctx.UtilitarioData.aplicaFormatoData(_ctx.state.retornoImportacaoOfx.dataInicial) + ' a ' + _ctx.UtilitarioData.aplicaFormatoData(_ctx.state.retornoImportacaoOfx.dataFinal)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.retornoImportacaoOfx.transacoes, (transacao, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                onClick: ($event: any) => (_ctx.defineMovimentoOfxSelecionado(index)),
                                class: _normalizeClass(_ctx.obterClassMovimentoOfx(index, transacao)),
                                key: index,
                                id: 'T-OFX-' + transacao.movimentoConta.identificadorMovimento,
                                title: 'N.Identificação no Banco: ' + transacao.movimentoConta.identificadorMovimento
                              }, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.storeSistema.state.layoutMobile ?
                    _ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(transacao.movimentoConta.dataMovimento) :
                    _ctx.UtilitarioData.aplicaFormatoData(transacao.movimentoConta.dataMovimento)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(transacao.movimentoConta.descricao), 1)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  ((transacao.movimentoConta.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "-" + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(transacao.movimentoConta.valor)), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(transacao.movimentoConta.valor)), 1))
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  ((transacao.statusConciliacao === _ctx.EStatusConciliacaoOfx.NaoConciliado))
                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 0,
                                        class: "ss-importacao-ofx-status ss-tag-vermelho"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Não")
                                        ]),
                                        _: 1
                                      }))
                                    : ((transacao.statusConciliacao === _ctx.EStatusConciliacaoOfx.Conciliado))
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 1,
                                          class: "ss-importacao-ofx-status ss-tag-verde"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Sim")
                                          ]),
                                          _: 1
                                        }))
                                      : ((transacao.statusConciliacao === _ctx.EStatusConciliacaoOfx.Ignorado))
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 2,
                                            color: "#f50",
                                            class: "ss-importacao-ofx-status"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Ignorado")
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                ])
                              ], 10, _hoisted_16))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }, 8, ["titulo"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.state.indexTransacaoSelecionada >= 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].statusConciliacao === _ctx.EStatusConciliacaoOfx.Conciliado))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.UtilitarioGeral.validaLista(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentosConciliados))
                                    ? (_openBlock(), _createBlock(_component_a_alert, {
                                        key: 0,
                                        message: "Movimento conciliado da seguinte forma:",
                                        type: "success",
                                        "show-icon": ""
                                      }))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentosConciliados, (movimentoConciliado) => {
                                    return (_openBlock(), _createBlock(_component_card, {
                                      titulo: " ",
                                      key: movimentoConciliado.codigo,
                                      class: "ss-importacao-ofx-probabilidades-card"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                              _createElementVNode("span", _hoisted_30, [
                                                _hoisted_31,
                                                _createTextVNode(" " + _toDisplayString(movimentoConciliado.identificadorMovimento), 1)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                              (_ctx.UtilitarioGeral.valorValido(movimentoConciliado.descricaoTipoDocumentoFinanceiro))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                                    _hoisted_34,
                                                    _createTextVNode(" " + _toDisplayString(movimentoConciliado.descricaoTipoDocumentoFinanceiro), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("span", _hoisted_37, [
                                                _hoisted_38,
                                                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(movimentoConciliado.dataMovimento)), 1)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_39, [
                                              _createElementVNode("span", _hoisted_40, [
                                                _hoisted_41,
                                                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(movimentoConciliado.valor)), 1)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_42, [
                                              _createElementVNode("span", _hoisted_43, [
                                                _hoisted_44,
                                                (movimentoConciliado.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _hoisted_45,
                                                      _createTextVNode("Pagamento ")
                                                    ], 64))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _hoisted_46,
                                                      _createTextVNode("Recebimento ")
                                                    ], 64))
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("span", _hoisted_47, [
                                            _hoisted_48,
                                            _createTextVNode(" " + _toDisplayString(movimentoConciliado.descricao), 1)
                                          ]),
                                          (_ctx.UtilitarioGeral.valorValido(movimentoConciliado.nomePessoa))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                                _hoisted_50,
                                                _createTextVNode(" " + _toDisplayString(movimentoConciliado.nomePessoa), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.UtilitarioGeral.valorValido(movimentoConciliado.nomePlanoContaCategoria))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                                _hoisted_52,
                                                _createTextVNode(" " + _toDisplayString(movimentoConciliado.nomePlanoContaCategoria), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  _createElementVNode("a", {
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.desconciliarVariosMovimentos(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentosConciliados))),
                                    class: "ss-importacao-ofx-probabilidades-acao"
                                  }, [
                                    _createVNode(_component_icone, { nome: "voltar" }),
                                    _createTextVNode("Desconciliar ")
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].provaveisMovimentosFinanceiros, (provaveisMovimentos, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createVNode(_component_a_alert, {
                                  message: _ctx.obtemTextoDetalheMovimentoConta(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.tipoMovimento, provaveisMovimentos.probabilidadeInformacao, provaveisMovimentos.movimentosFinanceiros.length),
                                  type: _ctx.obtemTipoAlertaBaseadoNaProbabilidade(provaveisMovimentos.probabilidadeInformacao),
                                  "show-icon": ""
                                }, null, 8, ["message", "type"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provaveisMovimentos.movimentosFinanceiros, (movimentoFinanceiro) => {
                                  return (_openBlock(), _createBlock(_component_card, {
                                    key: movimentoFinanceiro.codigo,
                                    titulo: " ",
                                    class: "ss-importacao-ofx-probabilidades-card"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("span", _hoisted_56, [
                                              _hoisted_57,
                                              _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.identificadorMovimento), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_58, [
                                            (_ctx.UtilitarioGeral.valorValido(movimentoFinanceiro.descricaoTipoDocumentoFinanceiro))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                                                  _hoisted_60,
                                                  _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.descricaoTipoDocumentoFinanceiro), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("span", _hoisted_63, [
                                              _hoisted_64,
                                              _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(movimentoFinanceiro.dataMovimento)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_65, [
                                            _createElementVNode("span", _hoisted_66, [
                                              _hoisted_67,
                                              _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(movimentoFinanceiro.valor)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_68, [
                                            _createElementVNode("span", _hoisted_69, [
                                              _hoisted_70,
                                              (movimentoFinanceiro.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _hoisted_71,
                                                    _createTextVNode("Pagamento ")
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _hoisted_72,
                                                    _createTextVNode("Recebimento ")
                                                  ], 64))
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("span", _hoisted_73, [
                                          _hoisted_74,
                                          _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.descricao), 1)
                                        ]),
                                        (_ctx.UtilitarioGeral.valorValido(movimentoFinanceiro.nomePessoa))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                                              _hoisted_76,
                                              _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.nomePessoa), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.UtilitarioGeral.valorValido(movimentoFinanceiro.nomePlanoContaCategoria))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                              _hoisted_78,
                                              _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.nomePlanoContaCategoria), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].statusConciliacao !== _ctx.EStatusConciliacaoOfx.Conciliado && provaveisMovimentos.probabilidadeInformacao !== _ctx.EProbabilidadeConciliacao.SomaVariosMovimentos))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              ((_ctx.verificaMovimentoConciliado(movimentoFinanceiro.codigo)))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                                    _createVNode(_component_icone, { nome: "checklist" }),
                                                    _createTextVNode("Conciliado por outro movimento deste arquivo OFX. ")
                                                  ]))
                                                : (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    onClick: ($event: any) => (_ctx.conciliar(movimentoFinanceiro)),
                                                    class: "ss-importacao-ofx-probabilidades-acao"
                                                  }, [
                                                    _createVNode(_component_icone, { nome: "checklist" }),
                                                    _createTextVNode("Conciliar ")
                                                  ], 8, _hoisted_80))
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (provaveisMovimentos.probabilidadeInformacao === _ctx.EProbabilidadeConciliacao.SomaVariosMovimentos)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.conciliarVariosMovimentos(provaveisMovimentos.movimentosFinanceiros)),
                                      class: "ss-importacao-ofx-probabilidades-acao"
                                    }, [
                                      _createVNode(_component_icone, { nome: "checklist" }),
                                      _createTextVNode("Conciliar todos ")
                                    ], 8, _hoisted_81))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].statusConciliacao !== _ctx.EStatusConciliacaoOfx.Conciliado))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].provaveisTitulosFinanceiros, (provaveisTitulos, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].statusConciliacao === _ctx.EStatusConciliacaoOfx.NaoConciliado))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                            _createVNode(_component_a_alert, {
                                              message: _ctx.obtemTextoDetalheMovimentoTituloPendente(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.tipoMovimento, provaveisTitulos.probabilidadeInformacao, provaveisTitulos.titulosFinanceiros.length),
                                              type: _ctx.obtemTipoAlertaBaseadoNaProbabilidade(provaveisTitulos.probabilidadeInformacao),
                                              "show-icon": ""
                                            }, null, 8, ["message", "type"]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provaveisTitulos.titulosFinanceiros, (tituloFinanceiro) => {
                                              return (_openBlock(), _createBlock(_component_card, {
                                                key: tituloFinanceiro.codigo,
                                                titulo: " ",
                                                class: "ss-importacao-ofx-probabilidades-card"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_83, [
                                                    _createElementVNode("div", _hoisted_84, [
                                                      _createElementVNode("div", _hoisted_85, [
                                                        _createElementVNode("span", _hoisted_86, [
                                                          _hoisted_87,
                                                          _createTextVNode(" " + _toDisplayString(tituloFinanceiro.numeroTitulo), 1)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_88, [
                                                        _createElementVNode("span", _hoisted_89, [
                                                          _hoisted_90,
                                                          _createTextVNode(" " + _toDisplayString(tituloFinanceiro.descricaoTipoDocumentoFinanceiro), 1)
                                                        ])
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_91, [
                                                      _createElementVNode("div", _hoisted_92, [
                                                        _createElementVNode("span", _hoisted_93, [
                                                          _hoisted_94,
                                                          _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(tituloFinanceiro.dataVencimento)), 1)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_95, [
                                                        _createElementVNode("span", _hoisted_96, [
                                                          _hoisted_97,
                                                          _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(tituloFinanceiro.saldo)), 1)
                                                        ])
                                                      ])
                                                    ]),
                                                    _createElementVNode("span", _hoisted_98, [
                                                      _hoisted_99,
                                                      _createTextVNode(" " + _toDisplayString(tituloFinanceiro.nomePessoa), 1)
                                                    ]),
                                                    _createElementVNode("span", _hoisted_100, [
                                                      _hoisted_101,
                                                      _createTextVNode(" " + _toDisplayString(tituloFinanceiro.nomePlanoContaCategoria), 1)
                                                    ]),
                                                    ((_ctx.verificaBaixaTitulo(tituloFinanceiro.codigo)))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_102, [
                                                          _createVNode(_component_icone, { nome: "checklist" }),
                                                          _createTextVNode("Baixado e conciliado por outro movimento deste arquivo OFX. ")
                                                        ]))
                                                      : ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor === tituloFinanceiro.saldo))
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            onClick: ($event: any) => (_ctx.efetuarBaixaConciliar([tituloFinanceiro], 0, 0)),
                                                            class: "ss-importacao-ofx-probabilidades-acao"
                                                          }, [
                                                            _createVNode(_component_icone, { nome: "carteira-entrada" }),
                                                            _createTextVNode("Baixar e conciliar ")
                                                          ], 8, _hoisted_103))
                                                        : ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor > tituloFinanceiro.saldo))
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 2,
                                                              onClick: ($event: any) => (_ctx.abrirConfirmacaoCategoriaBaixa(tituloFinanceiro, (_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor - tituloFinanceiro.saldo), 0)),
                                                              class: "ss-importacao-ofx-probabilidades-acao"
                                                            }, [
                                                              _createVNode(_component_icone, { nome: "carteira-entrada" }),
                                                              _createTextVNode("Baixar e conciliar com Juros/Multa no valor de R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor
                            - tituloFinanceiro.saldo)), 1)
                                                            ], 8, _hoisted_104))
                                                          : ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor < tituloFinanceiro.saldo))
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 3,
                                                                onClick: ($event: any) => (_ctx.abrirConfirmacaoCategoriaBaixa(tituloFinanceiro, 0, (tituloFinanceiro.saldo - _ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor))),
                                                                class: "ss-importacao-ofx-probabilidades-acao"
                                                              }, [
                                                                _createVNode(_component_icone, { nome: "carteira-entrada" }),
                                                                _createTextVNode("Baixar e conciliar com Desconto no valor de R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(tituloFinanceiro.saldo -
                            _ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor)), 1)
                                                              ], 8, _hoisted_105))
                                                            : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  (_ctx.state.movimentosFinanceirosSelecionados.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                        _hoisted_107,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.movimentosFinanceirosSelecionados, (movimentoFinanceiro) => {
                                          return (_openBlock(), _createBlock(_component_card, {
                                            key: movimentoFinanceiro.codigo,
                                            titulo: " ",
                                            class: "ss-importacao-ofx-probabilidades-card"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_108, [
                                                _createElementVNode("a", {
                                                  title: "Remover movimento",
                                                  onClick: ($event: any) => (_ctx.removerMovimentoFinanceiroSelecionado(movimentoFinanceiro.codigo)),
                                                  style: {"position":"absolute","right":"10px"}
                                                }, [
                                                  _createVNode(_component_icone, { nome: "excluir" })
                                                ], 8, _hoisted_109),
                                                _createElementVNode("div", _hoisted_110, [
                                                  _createElementVNode("div", _hoisted_111, [
                                                    _createElementVNode("span", _hoisted_112, [
                                                      _hoisted_113,
                                                      _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.identificadorMovimento), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_114, [
                                                    _createElementVNode("span", _hoisted_115, [
                                                      _hoisted_116,
                                                      _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.descricaoTipoDocumentoFinanceiro), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_117, [
                                                  _createElementVNode("div", _hoisted_118, [
                                                    _createElementVNode("span", _hoisted_119, [
                                                      _hoisted_120,
                                                      _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(movimentoFinanceiro.dataMovimento)), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_121, [
                                                    _createElementVNode("span", null, [
                                                      _hoisted_122,
                                                      _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(movimentoFinanceiro.valor)), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_123, [
                                                    _createElementVNode("span", null, [
                                                      _hoisted_124,
                                                      (movimentoFinanceiro.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _hoisted_125,
                                                            _createTextVNode("Pagamento ")
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _hoisted_126,
                                                            _createTextVNode("Recebimento ")
                                                          ], 64))
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("span", _hoisted_127, [
                                                  _hoisted_128,
                                                  _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.nomePessoa), 1)
                                                ]),
                                                _createElementVNode("span", _hoisted_129, [
                                                  _hoisted_130,
                                                  _createTextVNode(" " + _toDisplayString(movimentoFinanceiro.nomePlanoContaCategoria), 1)
                                                ])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128)),
                                        ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor === _ctx.state.totalMovimentosSelecionados))
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.conciliarVariosMovimentos(_ctx.state.movimentosFinanceirosSelecionados))),
                                              class: "ss-importacao-ofx-probabilidades-acao"
                                            }, [
                                              _createVNode(_component_icone, { nome: "carteira-entrada" }),
                                              _createTextVNode("Conciliar todos movimentos selecionados. ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.UtilitarioGeral.valorValido(_ctx.state.mensagemMovimentosSelecionados))
                                          ? (_openBlock(), _createBlock(_component_a_alert, {
                                              key: 1,
                                              message: _ctx.state.mensagemMovimentosSelecionados,
                                              type: "warning",
                                              "show-icon": ""
                                            }, null, 8, ["message"]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("a", {
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.limparBuscaMovimentosFinanceiros())),
                                          class: "ss-importacao-ofx-probabilidades-acao"
                                        }, [
                                          _createVNode(_component_icone, { nome: "excluir" }),
                                          _createTextVNode("Remover todos movimentos selecionados. ")
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.novoMovimento())),
                                    class: "ss-importacao-ofx-probabilidades-acao"
                                  }, [
                                    _createVNode(_component_icone, { nome: "novo" }),
                                    _createTextVNode("Criar um novo movimento na Conta ")
                                  ]),
                                  _createElementVNode("a", {
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.abrirBuscaMovimentosFinanceiros())),
                                    class: "ss-importacao-ofx-probabilidades-acao"
                                  }, [
                                    _createVNode(_component_icone, { nome: "pesquisar" }),
                                    _createTextVNode("Buscar um ou mais Movimentos na Conta ")
                                  ]),
                                  _createElementVNode("a", {
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.abrirTransferencia())),
                                    class: "ss-importacao-ofx-probabilidades-acao"
                                  }, [
                                    _createVNode(_component_icone, { nome: "troca" }),
                                    _createTextVNode("Efetuar uma Transferência entre Contas ")
                                  ]),
                                  ((_ctx.state.titulosFinanceirosSelecionados.length <= 0))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.abrirBuscaTitulos(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.tipoMovimento))),
                                        class: "ss-importacao-ofx-probabilidades-acao"
                                      }, [
                                        _createVNode(_component_icone, { nome: "pesquisar" }),
                                        _createTextVNode("Buscar e baixar uma ou mais " + _toDisplayString(_ctx.obtemTextoContasPendentes(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.tipoMovimento)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.ignorarMovimento())),
                                    class: "ss-importacao-ofx-probabilidades-acao"
                                  }, [
                                    _createVNode(_component_icone, { nome: "informacoes" }),
                                    _createTextVNode("Ignorar movimento ")
                                  ]),
                                  (_ctx.state.titulosFinanceirosSelecionados.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                        _hoisted_132,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.titulosFinanceirosSelecionados, (tituloFinanceiro) => {
                                          return (_openBlock(), _createBlock(_component_card, {
                                            key: tituloFinanceiro.codigo,
                                            titulo: " ",
                                            class: "ss-importacao-ofx-probabilidades-card"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_133, [
                                                _createElementVNode("a", {
                                                  title: "Remover título da Baixa",
                                                  onClick: ($event: any) => (_ctx.removerTituloSelecionado(tituloFinanceiro.codigo)),
                                                  style: {"position":"absolute","right":"10px"}
                                                }, [
                                                  _createVNode(_component_icone, { nome: "excluir" })
                                                ], 8, _hoisted_134),
                                                _createElementVNode("div", _hoisted_135, [
                                                  _createElementVNode("div", _hoisted_136, [
                                                    _createElementVNode("span", _hoisted_137, [
                                                      _hoisted_138,
                                                      _createTextVNode(" " + _toDisplayString(tituloFinanceiro.numeroTitulo), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_139, [
                                                    _createElementVNode("span", _hoisted_140, [
                                                      _hoisted_141,
                                                      _createTextVNode(" " + _toDisplayString(tituloFinanceiro.descricaoTipoDocumentoFinanceiro), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_142, [
                                                  _createElementVNode("div", _hoisted_143, [
                                                    _createElementVNode("span", _hoisted_144, [
                                                      _hoisted_145,
                                                      _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(tituloFinanceiro.dataVencimento)), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_146, [
                                                    _createElementVNode("span", null, [
                                                      _hoisted_147,
                                                      _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(tituloFinanceiro.saldo)), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("span", _hoisted_148, [
                                                  _hoisted_149,
                                                  _createTextVNode(" " + _toDisplayString(tituloFinanceiro.nomePessoa), 1)
                                                ]),
                                                _createElementVNode("span", _hoisted_150, [
                                                  _hoisted_151,
                                                  _createTextVNode(" " + _toDisplayString(tituloFinanceiro.nomePlanoContaCategoria), 1)
                                                ]),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.valoresTitulosSelecionados, (valorTituloBaixa) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                                    key: valorTituloBaixa.codigoTituloFinanceiro
                                                  }, [
                                                    (valorTituloBaixa.codigoTituloFinanceiro === tituloFinanceiro.codigo)
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 'ValoresBaixaTitulo' + valorTituloBaixa.codigoTituloFinanceiro,
                                                          class: "ant-row"
                                                        }, [
                                                          _createElementVNode("div", _hoisted_152, [
                                                            _createElementVNode("span", _hoisted_153, [
                                                              _hoisted_154,
                                                              _createVNode(_component_campo_numerico, {
                                                                classCss: "ss-importacao-ofx-valores-baixa",
                                                                dataAttributeColuna: "ValorJurosMulta",
                                                                monetario: true,
                                                                quantidadeCasasDecimais: 2,
                                                                valor: valorTituloBaixa.valorJurosMulta,
                                                                "onUpdate:valor": ($event: any) => ((valorTituloBaixa.valorJurosMulta) = $event),
                                                                valorMaximo: tituloFinanceiro.saldo,
                                                                onKeydown: [
                                                                  _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                                                  _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, 'ValorJurosMulta')), ["prevent"]), ["down"])),
                                                                  _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, 'ValorJurosMulta')), ["prevent"]), ["up"]))
                                                                ],
                                                                onValorDigitado: _cache[21] || (_cache[21] = ($event: any) => (_ctx.calcularTotalBaixaTitulosSelecionados()))
                                                              }, null, 8, ["valor", "onUpdate:valor", "valorMaximo"])
                                                            ])
                                                          ]),
                                                          _hoisted_155,
                                                          _createElementVNode("div", _hoisted_156, [
                                                            _createElementVNode("span", _hoisted_157, [
                                                              _hoisted_158,
                                                              _createVNode(_component_campo_numerico, {
                                                                classCss: "ss-importacao-ofx-valores-baixa",
                                                                dataAttributeColuna: "ValorDesconto",
                                                                monetario: true,
                                                                quantidadeCasasDecimais: 2,
                                                                valor: valorTituloBaixa.valorDesconto,
                                                                "onUpdate:valor": ($event: any) => ((valorTituloBaixa.valorDesconto) = $event),
                                                                valorMaximo: tituloFinanceiro.saldo,
                                                                onKeydown: [
                                                                  _cache[22] || (_cache[22] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                                                  _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, 'ValorDesconto')), ["prevent"]), ["down"])),
                                                                  _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, 'ValorDesconto')), ["prevent"]), ["up"]))
                                                                ],
                                                                onValorDigitado: _cache[25] || (_cache[25] = ($event: any) => (_ctx.calcularTotalBaixaTitulosSelecionados()))
                                                              }, null, 8, ["valor", "onUpdate:valor", "valorMaximo"])
                                                            ])
                                                          ])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 128))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128)),
                                        ((_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.valor === _ctx.state.totalBaixaTitulosSelecionados))
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.efetuarBaixaConciliar(_ctx.state.titulosFinanceirosSelecionados, 0, 0, true))),
                                              class: "ss-importacao-ofx-probabilidades-acao"
                                            }, [
                                              _createVNode(_component_icone, { nome: "carteira-entrada" }),
                                              _createTextVNode("Baixar e conciliar ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.UtilitarioGeral.valorValido(_ctx.state.mensagemBaixaTitulosSelecionados))
                                          ? (_openBlock(), _createBlock(_component_a_alert, {
                                              key: 1,
                                              message: _ctx.state.mensagemBaixaTitulosSelecionados,
                                              type: "warning",
                                              "show-icon": ""
                                            }, null, 8, ["message"]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("a", {
                                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.abrirBuscaTitulos(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.tipoMovimento))),
                                          class: "ss-importacao-ofx-probabilidades-acao"
                                        }, [
                                          _createVNode(_component_icone, { nome: "pesquisar" }),
                                          _createTextVNode("Buscar uma ou mais " + _toDisplayString(_ctx.obtemTextoContasPendentes(_ctx.state.retornoImportacaoOfx.transacoes[_ctx.state.indexTransacaoSelecionada].movimentoConta.tipoMovimento)), 1)
                                        ]),
                                        _createElementVNode("a", {
                                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.limparBuscaTitulos())),
                                          class: "ss-importacao-ofx-probabilidades-acao"
                                        }, [
                                          _createVNode(_component_icone, { nome: "excluir" }),
                                          _createTextVNode("Remover todos títulos selecionados. ")
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_movimento_financeiro_modal, {
        operacao: _ctx.state.operacaoLancamento,
        conta: _ctx.state.codigoConta,
        visivel: _ctx.state.exibirLancamento,
        "onUpdate:visivel": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
        movimentoPrePreenchido: _ctx.state.movimentoPrePreechido,
        "data-competencia": _ctx.UtilitarioData.obterDataAtual(),
        onConfirmacao: _cache[30] || (_cache[30] = ($event: any) => (_ctx.concluirConciliacao()))
      }, null, 8, ["operacao", "conta", "visivel", "movimentoPrePreenchido", "data-competencia"]),
      _createVNode(_component_transferencia_contas_modal, {
        empresa: _ctx.props.empresa,
        visivel: _ctx.state.exibirTransferencia,
        "onUpdate:visivel": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.exibirTransferencia) = $event)),
        movimentoPrePreenchido: _ctx.state.movimentoPrePreechido,
        onConfirmacao: _cache[32] || (_cache[32] = ($event: any) => (_ctx.concluirConciliacao()))
      }, null, 8, ["empresa", "visivel", "movimentoPrePreenchido"]),
      _createVNode(_component_buscar_titulos_modal, {
        visivel: _ctx.state.exibirBuscaTitulos,
        "onUpdate:visivel": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.exibirBuscaTitulos) = $event)),
        empresa: _ctx.props.empresa,
        tipoTitulo: _ctx.state.tipoTituloFinanceiroBusca,
        tituloTela: _ctx.state.tituloModalBusca,
        apenasTitulosPendentes: true,
        omitirTitulos: _ctx.omitirTitulosBusca(),
        onConfirmacao: _cache[34] || (_cache[34] = ($event: any) => (_ctx.preencherTitulosSelecionados($event)))
      }, null, 8, ["visivel", "empresa", "tipoTitulo", "tituloTela", "omitirTitulos"]),
      _createVNode(_component_buscar_movimentos_financeiros_modal, {
        visivel: _ctx.state.exibirBuscaMovimentos,
        "onUpdate:visivel": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.exibirBuscaMovimentos) = $event)),
        empresa: _ctx.props.empresa,
        conta: _ctx.state.codigoConta,
        dataEspecifica: _ctx.state.dataBuscaMovimento,
        tipoMovimento: _ctx.state.tipoMovimentoFinanceiroBusca,
        tituloTela: _ctx.state.tituloModalBuscaMovimento,
        movimentoOfx: _ctx.state.movimentoBuscaOfx,
        apenasSemNumeroControle: true,
        onConfirmacao: _cache[36] || (_cache[36] = ($event: any) => (_ctx.preencherMovimentosFinanceirosSelecionados($event)))
      }, null, 8, ["visivel", "empresa", "conta", "dataEspecifica", "tipoMovimento", "tituloTela", "movimentoOfx"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_a_modal, {
        title: "Confirme a categoria para realizar a Baixa",
        visible: _ctx.state.exibirConfirmacaoCategoriaBaixa,
        "onUpdate:visible": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.exibirConfirmacaoCategoriaBaixa) = $event)),
        width: 600,
        centered: ""
      }, {
        closeIcon: _withCtx(() => [
          _createVNode(_component_icone, { nome: "voltar" })
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.confirmarCategoriaBaixa()))
            }, _hoisted_160)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              ((_ctx.state.valorJurosMulta > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, [
                      _createVNode(_component_a_form_item, { label: "Categoria Juros/Multa" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_categoria_plano_conta, {
                            codigoSelecionado: _ctx.state.codigoCategoriaJurosMulta,
                            "onUpdate:codigoSelecionado": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.codigoCategoriaJurosMulta) = $event)),
                            empresas: [_ctx.props.empresa]
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : ((_ctx.state.valorDesconto > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                      _createElementVNode("div", _hoisted_164, [
                        _createVNode(_component_a_form_item, { label: "Categoria Desconto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_categoria_plano_conta, {
                              codigoSelecionado: _ctx.state.codigoCategoriaDesconto,
                              "onUpdate:codigoSelecionado": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.codigoCategoriaDesconto) = $event)),
                              empresas: [_ctx.props.empresa]
                            }, null, 8, ["codigoSelecionado", "empresas"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}